<template lang="pug">
    #app
        Sidebar(ref="sidebar" v-if="! error && loaded" @mounted="init")
        #panel(ref="panel")
            #error.is-fullheight(v-if="! loaded && error")
                Error(:code="error.code || 500" :message="error.message")
            #initializing(v-else-if="! loaded")
                Loading(:active="! loaded" color="#95c021")
            #main(v-else)
                HeaderMenu.navbar
                Header
                #content(:class="{ error: error, loading: ! ready }")
                    #content-error.container(v-if="ready && error")
                        Error(:code="error.code || 500" :message="error.message")
                    // loading(:active="! ready" :is-full-page="false" :height="40" :width="40" color="#95c021")
                    vue-progress-bar
                    // transition(name="slide-fade" mode="out-in")
                    //     router-view(:key="$route.path")
                    main(v-if="! error")
                        router-view(:key="$route.path")
                Footer
        .notification-wrap
            Message(v-for="message in messages" :key="message.id" :content="message")
</template>

<script>

// import _ from 'lodash'
import Slideout from 'slideout'

import Loading from 'vue-loading-overlay'

import Error from '@/components/Error.vue'
import HeaderMenu from '@/components/HeaderMenu.vue'
import Sidebar from '@/components/Sidebar.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Message from '@/components/Features/Message';

import { mapGetters, mapMutations } from 'vuex'

export default {
    name: 'app',
    data() {
        return {
            slideout: undefined,
        }
    },
    components: {
        Error,
        Loading,
        HeaderMenu,
        Sidebar,
        Header,
        Footer,
        Message
    },
    watch: {
        sidebar(value) {
            if (this.slideout && value === true && this.slideout.isOpen() === false)
                setTimeout(() => this.slideout.open(), 150)
            else if (this.slideout && value === false && this.slideout.isOpen() === true)
                this.slideout.close()
        }
    },
    computed: {
        ...mapGetters({
            loaded: 'loaded',
            ready: 'ready',
            error: 'error',
            sidebar: 'sidebar',
            messages: 'messages'
        }),
    },
    methods: {
        init() {
            this.slideout = new Slideout({
                panel: this.$refs.panel,
                menu: this.$refs.sidebar.$el,
                padding: 256,
                tolerance: 70,
                // touch: false,
            })

            this.slideout.on('open', () => this.updateSidebarVisibility(true));
            this.slideout.on('close', () => this.updateSidebarVisibility(false));

            window.addEventListener('resize', () => {
                if (window.innerWidth >= 1088) this.updateSidebarVisibility(false)
            })
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility',
        })
    },
    mounted() {
        this.$Progress.finish()
    }
}
</script>

<style lang="sass">

    @import 'assets/sass/globals';
    @import '~@/assets/sass/variables';
    @import '~vue-loading-overlay/dist/vue-loading.css';

    body
        font-family: $font

    #panel
        background-color: #ffffff;
        box-shadow: $box-shadow-5;
    #main
        min-height: 100vh;
        display: flex;
        flex-direction: column;
        #content
            flex-grow: 1;
            width: 100%;
            position: relative
            &.error
                display: flex;
                #content-error
                    flex-grow: 1;
                    font-size: .82rem;
            &.loading main
                opacity: .8
                filter: blur(2px)
            main
                transition: opacity .5s ease, filter .3s ease
    #error.is-fullheight
        height: 100vh;

    .page-enter-active,
    .page-leave-active
        transition: opacity .3s ease, transform .3s ease;
    .page-enter,
    .page-leave-to
        opacity: 0;
        transform: translateY(30px);

    .slide-fade-enter-active
        transition: all .35s ease;
    .slide-fade-leave-active
        transition: all .35s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    .slide-fade-enter, .slide-fade-leave-to
        transform: translateY(10px);
        opacity: 0;

    // .fade-enter-active,
    // .fade-leave-active
    //     transition-duration: .3s;
    //     transition-property: opacity;
    //     transition-timing-function: ease;

    // .fade-enter-active
    //     transition-delay: .3s

    // .fade-enter,
    // .fade-leave-active
    //     opacity: 0;

    .vld-overlay
        z-index: 5
</style>
